import React, { useRef, useEffect, useState, useMemo } from 'react';
import { Container } from 'reactstrap';
import TableContainer from './TableContainer';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Constants from "./Constants";
import './SITLSearch.css';
import { MenuItem, Select, Button, Paper, Grid, TextField, Autocomplete, CircularProgress } from '@mui/material';

export const calculate_zone = (eventdate) => {
    if (eventdate) {
        var myLocal = eventdate.getHours();
        var myUtc = eventdate.getUTCHours();
        if (myUtc < 4) {
            myUtc += 24;
        }
        return myLocal - myUtc;
    }
    return 0
}

/*
This turned out to be useless as when I try to use it from the ControlForm I get a React Error in console.
 */
export const getStartTimeForDatePicker = (datestring_from_row, alreadyGMT) => {

    var input = new Date(datestring_from_row);
    var zd = 0;
    if (!alreadyGMT) {
        zd = calculate_zone(input);
    }
    input.setHours(input.getHours() - zd);
    // First GMT
    // Then 2 hour setup.. if minutes > 30 then we'll do that hour
    input.setSeconds(0);
    var align_min = input.getMinutes();
    console.log(align_min);
    console.log("align_min: " + align_min);
    if (align_min > 0) {
        if (align_min > 30) {
            input.setMinutes(0);
        } else {
            input.setHours(input.getHours() - 1);
            input.setMinutes(0);
        }
    }
    return input;
}


export const SITLSearch = (props) => {
    const navigate = useNavigate(); // extract navigation prop here
    const location = useLocation();
    // const [searchTerm, setSearchTerm] = useState(location.state.sitlsearchterm);
    // const [criteria, setCriteria] = useState(JSON.parse(location.state.criteria));
    const [data, setData] = useState([]);
    const [mytable, setTable] = useState({
        order: 'asc',
        selected: [],
        //page: 0,
        searchField: props.searchTerm,
        //rowsPerPage: 25,
        //counter: 0,
        data: null
    });
    const buttonRef = useRef(null);
    //const options = Constants.SITL_SUGGEST;
    let mystuff = [{}];
    const [dropDown, setDropDown] = useState("");
    //add condition for best undefined
    if (typeof location.state.sitlsearchresults != "undefined") {
        mystuff = useState(JSON.parse(location.state.sitlsearchresults));
    }

    useEffect(() => {
        const contacts = mystuff;
        setData(contacts);
    }, []);
    /*
    Navigates back to Landing or Results page with new selected date or the
    passed in, original date
     */
    const assignToDatePicker = (row_value) => { //redirect 4
        //check to see if row value is not null or blank
        console.log('row_value', row_value);
        // if (!row_value) { // Keep original time button
        //     row_value = criteria.startTime;
        //     var passable_date = getStartTimeForDatePicker(row_value, 1);
        // } else { // get selected date and pass it back to landing page through shared store
        //     var passable_date = getStartTimeForDatePicker(row_value);
        // }

        //props.startTime = passable_date;
        //props.searchStartTime(row_value);
        // props.sharedStore.dispatch({
        //     type: 'SET_STARTTIME',
        //     value: passable_date
        // });

        // props.sharedStore.dispatch({ // So that the landing page can recieve on Retain date case
        //     type: 'SET_SITL', value: searchTerm
        // });

        // console.log("assign2: " + searchTerm)


        // var destination = "/results/"
        // if (location.state.context === "landingpage") {
        //     destination = "/"
        // }
        // props.startTime = passable_date;
        // props.sharedStore.dispatch({
        //     type: 'SET_STARTTIME',
        //     value: passable_date
        // });
    }
    const sitlSuggestMenuChange = (ev) => {
        if (ev.target.value !== '') {
            firstQuery(ev.target.value);
            setTable({
                ...mytable,
                searchField: ev.target.value
            });
            props.setSearchTerm(ev.target.value);
        }
        setDropDown(ev.target.value);
    }

    /*
    Queries the sitl table when the user is already on the SITL table search page
    then setData() at the end of the function triggers the table to update
     */



    const firstQuery = (initialSearchQuery) => { //redirect 4
        //Dont need this anymore
        // props.sharedStore.dispatch({ // So that the landing page can recieve
        //     // the new sitl-search-query term
        //     type: 'SET_SITL',
        //     value: initialSearchQuery
        // });
        console.log('initialSearchQuery', initialSearchQuery);

        if (initialSearchQuery.length < 2) { // must have at least two letters in search to search
            return
        }
        if (mytable) {
            axios.get('api/search_results?q=' + initialSearchQuery)
                .then((response) => {
                    console.log('response', response);
                    const rows = response.data.brstsegs;
                    var firstdata = [];
                    for (var i = 0; i < rows.length; ++i) {
                        firstdata.push(createData(i, rows[i].comment, rows[i].first_buffer, rows[i].fom));
                    }
                    setTable({
                        ...mytable, response: response,
                        data: firstdata,
                        counter: rows,
                        searchField: initialSearchQuery
                    });
                    setData(firstdata);
                    props.setSearchTerm(initialSearchQuery);
                });
            //Why is this happen outside of the then? 

            // if (mytable != null && mytable.data != null) {
            //     setData(mytable.data);
            //     setSearchTerm(initialSearchQuery);
            //     console.log("after setting:" + searchTerm)
            // }
        }
    }

    function createData(cntr, comment, time, fom) {
        return { id: cntr, comment, time, fom };
    }

    /*
    This is the simplified column object I got from
     https://medium.com/@thewidlarzgroup/react-table-7-sorting-filtering-pagination-and-more-6bc28af104d6
     */
    const columns = useMemo(
        () => [
            {
                Header: "SITL Comment",
                accessor: "comment",
                // sortable: false,
                // filterable: false,
                filter: 0,
                // disableSortBy: true,
                //disableGlobalFilter: true,
            },

            {
                Header: "Select Time",
                accessor: "time",
                filter: 0,
                // Cell: ({ value }) => (
                //     <input type="button"
                //         value={value}
                //         onClick={() => props.setSearchDateTime(value)}
                //     />
                // ),
            },
            {
                Header: "Figure of Merit",
                accessor: "fom",
                filter: -1,
            },
        ]
    )

    useEffect(() => {
        // setTimeout(() => {
        firstQuery(mytable.searchField);
        // }, 5000);
    }, []);
    /*
    The MuiTable component (SITL Search) with embedded Table and Filter components
     */

    const [inputValue, setInputValue] = useState("");
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    // Debounce timer
    let debounceTimer = null;

    const fetchSuggestions = (value) => {
        if (value.length < 2) {
            setOptions([]);
            return;
        }
        setLoading(true);
        axios.get(`/api/search_results?q=${encodeURIComponent(value)}`)
            .then((response) => {
                // Assuming response.data.brstsegs is an array of objects with a 'comment' field
                const suggestions = response.data.brstsegs.map(item => item.comment);
                setOptions(suggestions);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    const handleInputChange = (event, value) => {
        setInputValue(value);
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => fetchSuggestions(value), 300); // Debounce by 300ms
    };

    const handleOptionSelect = (event, value) => {
        if (value) {
            props.setSearchTerm(value);
            firstQuery(value); // <-- This triggers the search automatically
        }
    };

    return (
        <React.Fragment>
            <div class="search-result-container">
                <div class="search-fields">
                    <div class="auto-complete">
                    <Autocomplete
                        freeSolo
                        options={options}
                        inputValue={inputValue}
                        onInputChange={handleInputChange}
                        onChange={handleOptionSelect}
                        loading={loading}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Search SITL Comment"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                      e.stopPropagation(); // Prevent Autocomplete from selecting first option
                                      firstQuery(inputValue); // Search for the typed value
                                    }
                                  }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                    </div>
                    {/* <div className={'dropdown-div ' + (dropDown !== "" ? "minimize" : "")}>
                     <label class="dropdown-label" for="sitl-dropdown">
                            Top Searches
                        </label>
                        <select className='sitl-dropdown' id='sitl-dropdown' value={dropDown} onChange={(ev) => { // re-render these extra brackets and stuff prevent the function from being constantly called
                            sitlSuggestMenuChange(ev);
                        }}>
                            <option value=""></option>
                            {options.map(option => {
                                return (
                                    <option value={option}>{option}</option>
                                )
                            })}
                        </select>
                       
                    </div> */}
                </div>

                {/*<h4>Select Another Time Period To Plot</h4>


             <Button
                style={{
                    background: "#f0f0f0",
                    height: "60px"
                }}
                onClick={() => assignToDatePicker()}>
                Return (keep original date)
            </Button> */}


                <TableContainer
                    columns={columns}
                    data={data}
                    setClanderToDate={props.setClanderToDate}
                    dateObj={props.dateObj}
                />
            </div>
        </React.Fragment >
    );
};

export default SITLSearch